import { useMutation } from "@tanstack/react-query";

import { $apiV2, errorHandler } from "modules/global";

export const useFinishTest = () =>
  useMutation({
    mutationFn: async (ticketId?: number) => {
      const { data } = await $apiV2.post(`/dtm/finish`, { ticket_id: ticketId });

      return data;
    },
    onError: errorHandler()
  });
